(() => {
  const root = document.querySelector('.germination-component-bundle');
  if (!root) return;

  const sizeInputs = Array.from(root.querySelectorAll('.js-gcb-size'));
  const addBtn = root.querySelector('.js-gcb-add');
  const addBtnTextEl = addBtn ? addBtn.querySelector('.add-to-cart-text') : null;
  const addBtnSpinner = addBtn ? addBtn.querySelector('.loading__spinner, .loading-overlay__spinner') : null;
  const hint = root.querySelector('#gcb-hint');
  const qtyInput = root.querySelector('.js-gcb-cart-qty');
  const qtyDisplay = root.querySelector('#gcb-qty-select-display');
  const productVariantsEl = document.getElementById('gcb-product-variants');
  // The embedded JSON contains the related bundle products from `custom.related_bundles`.
  const relatedBundles = productVariantsEl ? JSON.parse(productVariantsEl.textContent) : [];
  const PREFERRED_BUNDLE_PRODUCT_BY_SIZE = {
    '4': 8472490016964,
    '6': 8472516296900,
  };

  const state = {
    size: '4',
    pack: '8',
  };

  const sectionId = root.getAttribute('data-section-id') || '';
  const totalPriceEl = sectionId ? document.getElementById('gcb-total-price-' + sectionId) : null;
  const totalOriginalPriceEl = sectionId ? document.getElementById('gcb-total-original-price-' + sectionId) : null;
  const totalDomeCountEl = sectionId ? document.getElementById('gcb-total-dome-count-' + sectionId) : null;
  const totalTrayCountEl = sectionId ? document.getElementById('gcb-total-tray-count-' + sectionId) : null;
  const defaultAddText = addBtnTextEl
    ? (addBtnTextEl.textContent || '').trim() || 'Add to Cart'
    : (addBtn ? (addBtn.textContent || '').trim() || 'Add to Cart' : 'Add to Cart');

  function setAddButtonText(text) {
    if (!addBtn) return;
    if (addBtnTextEl) {
      addBtnTextEl.textContent = text;
      return;
    }
    addBtn.textContent = text;
  }

  function setLoadingState(isLoading) {
    if (!addBtn) return;
    addBtn.classList.toggle('loading', !!isLoading);
    window.EGAtcFeedback?.[isLoading ? 'pending' : 'idle'](addBtn);
    if (addBtnSpinner) addBtnSpinner.classList.toggle('hidden', !isLoading);
    addBtn.disabled = !!isLoading;
    if (!isLoading) setAddButtonText(defaultAddText);
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  }

  function setIntelligemsPriceAttrs(el, variant) {
    if (!el || !variant?.id) return;
    el.setAttribute('data-variant-id', String(variant.id));
    if (variant.product_id) el.setAttribute('data-product-id', String(variant.product_id));
  }

  function refreshIntelligemsPrices() {
    if (typeof window.igData?.resetDom === 'function') window.igData.resetDom();
  }

  function getSelectedPackQuantity() {
    const qtyRaw = qtyInput?.value;
    return Math.max(1, Number.parseInt(qtyRaw || '1', 10) || 1);
  }

  const discountBands = [
    { minQty: 20, maxQty: null, discountPct: 0.40 },
    { minQty: 16, maxQty: 19, discountPct: 0.38 },
    { minQty: 12, maxQty: 15, discountPct: 0.35 },
    { minQty: 8, maxQty: 11, discountPct: 0.30 },
    { minQty: 5, maxQty: 7, discountPct: 0.20 },
    { minQty: 2, maxQty: 4, discountPct: 0.10 },
    { minQty: 1, maxQty: 1, discountPct: 0.00 }
  ];

  function getDiscountPct(qty) {
    for (var i = 0; i < discountBands.length; i++) {
      var band = discountBands[i];
      if (qty >= band.minQty && (band.maxQty === null || qty <= band.maxQty)) {
        return band.discountPct;
      }
    }
    return 0;
  }

  function getUnitsPerPack() {
    const unitsPerPackFromPack = Number(state.pack);
    if (Number.isFinite(unitsPerPackFromPack) && unitsPerPackFromPack > 0) {
      return unitsPerPackFromPack;
    }
    return state.size === '6' ? 12 : 8;
  }

  function getPerTypeCountPerPack() {
    return Math.max(1, Math.floor(getUnitsPerPack() / 2));
  }

  function getDiscountedTotalCents(unitPriceCents, qty) {
    const totalOriginalPriceCents = unitPriceCents * qty;
    const discountPct = getDiscountPct(qty);
    const rawTotalPriceCents = Math.round(totalOriginalPriceCents * (1 - discountPct));
    return discountPct > 0 ? Math.ceil(rawTotalPriceCents / 100) * 100 : rawTotalPriceCents;
  }

  function getOriginalTotalCents(unitPriceCents, unitCompareCents, qty) {
    if (Number.isFinite(unitCompareCents) && unitCompareCents > unitPriceCents) {
      return unitCompareCents * qty;
    }
    return unitPriceCents * qty;
  }

  function populateQtyOptions(variant) {
    if (!qtyInput || qtyInput.tagName !== 'SELECT' || !variant) return;

    const unitPriceCents = Number(variant?.price);
    if (!Number.isFinite(unitPriceCents) || unitPriceCents <= 0) return;

    const currentValue = getSelectedPackQuantity();
    const perTypeCountPerPack = getPerTypeCountPerPack();

    qtyInput.innerHTML = '';

    for (let p = 1; p <= 24; p++) {
      const option = document.createElement('option');
      option.value = String(p);

      const totalPriceCents = getDiscountedTotalCents(unitPriceCents, p);
      const unitSetCount = p * perTypeCountPerPack;
      const pricePerSetCents = Math.round(totalPriceCents / unitSetCount);
      const packsLabel = `${p} Pack${p !== 1 ? 's' : ''}`;

      option.textContent = `${packsLabel} (${formatMoney(pricePerSetCents)}/set)`;
      option.setAttribute('data-abbr', packsLabel);
      if (p === currentValue) option.selected = true;

      qtyInput.appendChild(option);
    }
  }

  function updateTopTotals(variant, packQty) {
    if (!variant) return;

    const qty = Math.max(1, Number.parseInt(packQty || '1', 10) || 1);
    const unitsPerPack = getUnitsPerPack();
    const totalUnits = qty * unitsPerPack;

    // The UI displays "X Domes and X Trays" where X is half the total unit count.
    // (8 total units => 4 domes + 4 trays)
    const perTypeCount = Math.floor(totalUnits / 2);
    if (totalDomeCountEl) totalDomeCountEl.textContent = String(perTypeCount);
    if (totalTrayCountEl) totalTrayCountEl.textContent = String(perTypeCount);

    const unitPriceCents = Number(variant?.price);
    const unitCompareCents = Number(variant?.compare_at_price);
    const totalPriceCents = Number.isFinite(unitPriceCents) ? getDiscountedTotalCents(unitPriceCents, qty) : 0;
    const totalOriginalCents = Number.isFinite(unitPriceCents)
      ? getOriginalTotalCents(unitPriceCents, unitCompareCents, qty)
      : NaN;
    const isOnSale = Number.isFinite(totalOriginalCents) && Number.isFinite(totalPriceCents) && totalOriginalCents > totalPriceCents;

    if (totalPriceEl) totalPriceEl.textContent = formatMoney(totalPriceCents);
    if (totalOriginalPriceEl) {
      if (isOnSale) {
        totalOriginalPriceEl.textContent = formatMoney(totalOriginalCents);
        totalOriginalPriceEl.style.display = '';
      } else {
        totalOriginalPriceEl.textContent = '';
        totalOriginalPriceEl.style.display = 'none';
      }
    }
  }

  function updateThemePrice(variant, quantity) {
    // Update the existing theme price block for the PDP.
    const scope = root.closest('.product__info-container') || root.closest('.product__info-wrapper') || document;
    const priceBlock = scope.querySelector('.no-js-hidden[id^="price-"]') || scope.querySelector('[id^="price-"]');
    const priceCandidates = priceBlock ? Array.from(priceBlock.querySelectorAll('.price')) : [];
    const priceRoot =
      priceCandidates.find((el) => el.querySelector('.price__sale, .price__regular')) ||
      priceBlock?.closest('.price') ||
      null;
    if (!priceBlock || !priceRoot) return false;

    const saleWrap = priceRoot.querySelector('.price__sale');
    const regularWrap = priceRoot.querySelector('.price__regular');

    const salePriceEl = saleWrap?.querySelector('.price-item--sale.price-item--last');
    const comparePriceEl = saleWrap?.querySelector('.price-item--regular');
    const regularPriceEl = regularWrap?.querySelector('.price-item--regular');
    const youSave = priceRoot.querySelector('.you-save');

    const qty = Math.max(1, Number.parseInt(quantity || '1', 10) || 1);
    const unitPriceCents = Number(variant?.price);
    const unitCompareCents = Number(variant?.compare_at_price);
    const priceCents = Number.isFinite(unitPriceCents) ? getDiscountedTotalCents(unitPriceCents, qty) : 0;
    const originalCents = Number.isFinite(unitPriceCents)
      ? getOriginalTotalCents(unitPriceCents, unitCompareCents, qty)
      : NaN;
    const isOnSale = Number.isFinite(originalCents) && Number.isFinite(priceCents) && originalCents > priceCents;
    const saleText = formatMoney(priceCents || 0);
    const compareText = isOnSale ? formatMoney(originalCents) : '';

    const hasSaleMarkup = !!saleWrap && !!salePriceEl;
    const hasRegularMarkup = !!regularWrap && !!regularPriceEl;

    // Ensure correct visibility behavior (theme CSS relies on these classes)
    // Important: some templates render ONLY `.price__sale` markup; if we remove `price--on-sale`
    // there is nothing left to display. In that case, keep `price--on-sale` true and just hide compare.
    const shouldShowSaleLayout = isOnSale || (hasSaleMarkup && !hasRegularMarkup);
    priceRoot.classList.toggle('price--on-sale', shouldShowSaleLayout);
    priceRoot.classList.toggle('price--sold-out', !variant.available);

    if (salePriceEl) salePriceEl.textContent = saleText;
    if (regularPriceEl) regularPriceEl.textContent = saleText;
    if (comparePriceEl) comparePriceEl.textContent = compareText;
    [priceRoot, salePriceEl, regularPriceEl, comparePriceEl].forEach((el) => setIntelligemsPriceAttrs(el, variant));
    if (comparePriceEl) {
      const compareContainer = comparePriceEl.closest('span') || comparePriceEl.parentElement;
      if (compareContainer && compareContainer.style) {
        compareContainer.style.display = isOnSale ? '' : 'none';
      }
    }

    if (youSave) {
      if (isOnSale) {
        const saveCents = Math.max(0, (originalCents || 0) - (priceCents || 0));
        youSave.textContent = `You save ${formatMoney(saveCents)}`;
        youSave.style.display = '';
      } else {
        youSave.textContent = '';
        youSave.style.display = 'none';
      }
    }

    refreshIntelligemsPrices();
    return true;
  }

  function getSelectedSize() {
    return root.querySelector('.js-gcb-size:checked')?.value || '4';
  }

  function normalizeText(s) {
    return (s || '').toString().toLowerCase();
  }

  function isBundleForSize(bundle, size) {
    const t = normalizeText(bundle?.title);
    const h = normalizeText(bundle?.handle);
    if (String(size) === '4') return t.includes('4-cell') || h.includes('4-cell') || t.includes('4 cell') || h.includes('4 cell');
    return t.includes('6-cell') || h.includes('6-cell') || t.includes('6 cell') || h.includes('6 cell');
  }

  function extractPackNumberFromVariant(variant) {
    const candidates = [];
    if (variant?.option1) candidates.push(variant.option1);
    if (variant?.option2) candidates.push(variant.option2);
    if (variant?.option3) candidates.push(variant.option3);
    if (variant?.public_title) candidates.push(variant.public_title);
    if (variant?.title) candidates.push(variant.title);

    // Prefer explicit "8 Pack(s)" patterns
    for (const c of candidates) {
      const m = (c || '').toString().match(/(\d+)\s*(?:pack|packs)\b/i);
      if (m) return Number(m[1]);
    }

    // Fallback: accept pure numbers (e.g. "8") or known sizes embedded in strings
    for (const c of candidates) {
      const m = (c || '').toString().match(/\b(8|12|16|24)\b/);
      if (m) return Number(m[1]);
    }

    return null;
  }

  function bundleHasPack(bundle, pack) {
    if (!bundle?.variants || !Array.isArray(bundle.variants)) return false;
    const target = Number(pack);
    if (!Number.isFinite(target) || !target) return false;

    return bundle.variants.some((v) => {
      const extracted = extractPackNumberFromVariant(v);
      if (extracted === target) return true;
      const nums = packNumbersFromVariant(v);
      return nums.includes(target);
    });
  }

  function pickBundleProductForSize(size, pack) {
    if (!Array.isArray(relatedBundles) || relatedBundles.length === 0) return null;

    // 0) Hard-map each size to the intended related bundle product when present.
    const preferredId = Number(PREFERRED_BUNDLE_PRODUCT_BY_SIZE[String(size)] || 0);
    if (preferredId) {
      const preferred = relatedBundles.find((b) => Number(b?.id) === preferredId);
      if (preferred) return preferred;
    }

    // 1) Prefer explicit size markers in title/handle.
    const direct = relatedBundles.find((b) => isBundleForSize(b, size));
    if (direct) return direct;

    // 2) If only one related bundle exists, use it.
    if (relatedBundles.length === 1) return relatedBundles[0];

    // 3) Try matching by the expected pack number present in variant titles/options.
    const target = Number(pack);
    if (Number.isFinite(target) && target) {
      const matches = relatedBundles.filter((b) => bundleHasPack(b, target));
      if (matches.length === 1) return matches[0];
      if (matches.length > 1) {
        // Prefer one that doesn't look like the opposite size (if that signal exists).
        const oppositeSize = String(size) === '6' ? '4' : '6';
        const notOpposite = matches.filter((b) => !isBundleForSize(b, oppositeSize));
        if (notOpposite.length >= 1) return notOpposite[0];
        return matches[0];
      }
    }

    // 4) Final fallback: first related bundle.
    return relatedBundles[0];
  }

  function pickVariantForPack(bundle, pack) {
    if (!bundle?.variants || !Array.isArray(bundle.variants)) return null;
    const target = Number(pack);
    if (!target) return null;
    let match = null;

    // Prefer variant whose "pack number" matches.
    const matches = bundle.variants.filter((v) => extractPackNumberFromVariant(v) === target);
    if (matches.length === 1) return matches[0];
    if (matches.length > 1) {
      // If Shopify Bundles generates multiple internal variants for the same "pack",
      // pick the one that is available; otherwise prefer one that looks like the true bundle.
      const preferred = matches.find((v) => v.available) ||
        matches.find((v) => normalizeText(v.title).includes('domes') && normalizeText(v.title).includes('tray')) ||
        matches.find((v) => normalizeText(v.public_title).includes('domes') && normalizeText(v.public_title).includes('tray')) ||
        matches[0];
      return preferred || null;
    }

    // Fallback: if only 2 variants, pick by sorted pack number
    const withPack = bundle.variants
      .map((v) => ({ v, pack: extractPackNumberFromVariant(v) }))
      .filter((x) => typeof x.pack === 'number');
    if (withPack.length >= 1) {
      const sorted = withPack.sort((a, b) => (a.pack || 0) - (b.pack || 0));
      match = sorted.find((x) => x.pack === target)?.v || null;
    }

    return match || null;
  }

  function packNumbersFromVariant(variant) {
    // Shopify Bundles-style products may encode pack count twice (e.g. "16 Packs / 16 Packs").
    const candidates = [variant?.option1, variant?.option2, variant?.option3, variant?.public_title, variant?.title]
      .filter(Boolean)
      .map((x) => x.toString());

    const nums = [];
    for (const c of candidates) {
      const matches = c.match(/\b(8|12|16|24)\b/g);
      if (matches) nums.push(...matches.map((m) => Number(m)));
    }
    return nums.filter((n) => Number.isFinite(n));
  }

  function pickFirstAvailableVariant(bundle) {
    if (!bundle?.variants || !Array.isArray(bundle.variants)) return null;
    return bundle.variants.find((v) => v.available) || bundle.variants[0] || null;
  }

  function uniquePackNumbersFromBundle(bundle) {
    if (!bundle?.variants || !Array.isArray(bundle.variants)) return [];

    const nums = [];
    for (const v of bundle.variants) {
      const extracted = extractPackNumberFromVariant(v);
      if (Number.isFinite(extracted)) nums.push(extracted);

      const embedded = packNumbersFromVariant(v);
      if (embedded?.length) nums.push(...embedded);
    }

    const unique = Array.from(new Set(nums.filter((n) => Number.isFinite(n) && n > 0)));
    unique.sort((a, b) => a - b);
    return unique;
  }

  function pickPreferredPackForBundle(bundle, preferredPacks) {
    const available = uniquePackNumbersFromBundle(bundle);
    const desired = (preferredPacks || [])
      .map((p) => Number(p))
      .filter((n) => Number.isFinite(n) && n > 0);

    for (const d of desired) {
      if (available.includes(d)) return String(d);
    }
    return available.length ? String(available[0]) : null;
  }

  function pickVariantForPackAsSingleLineItem(bundle, pack) {
    if (!bundle?.variants || !Array.isArray(bundle.variants)) return null;
    const target = Number(pack);
    if (!target) return null;

    // Prefer variants where BOTH (or all) embedded pack numbers equal the selected pack,
    // e.g. "16 Packs / 16 Packs" instead of "16 Packs / 8 Packs".
    const strict = bundle.variants.filter((v) => {
      const nums = packNumbersFromVariant(v);
      if (nums.length < 2) return false;
      return nums.every((n) => n === target);
    });
    if (strict.length === 1) return strict[0];
    if (strict.length > 1) return strict.find((v) => v.available) || strict[0] || null;

    // Fallback: any variant that contains the pack number at least once.
    const loose = bundle.variants.filter((v) => packNumbersFromVariant(v).includes(target));
    if (loose.length === 1) return loose[0];
    if (loose.length > 1) return loose.find((v) => v.available) || loose[0] || null;

    return null;
  }

  function updateUI() {
    state.size = getSelectedSize();
    // Pack is fixed by size (no pack selector UI). Prefer the smallest pack and scale via Quantity.
    const preferredPacks = state.size === '6' ? ['12', '24'] : ['8', '16'];
    state.pack = preferredPacks[0];

    // Update "selected" labels like Birdies UI (after pack is normalized)
    const sizeSelected = root.querySelector('#gcb-size-selected');
    if (sizeSelected) sizeSelected.textContent = state.size === '6' ? '6-Cell' : '4-Cell 3" or 4"';

    // Find the related bundle product for the selected size.
    const bundleProduct = pickBundleProductForSize(state.size, state.pack);
    const resolvedPack = pickPreferredPackForBundle(bundleProduct, preferredPacks);
    if (resolvedPack) state.pack = resolvedPack;

    // User request: add ONE line item. Prefer a “true pack” variant like "16/16" (not "16/8").
    let bundleVariant =
      pickVariantForPackAsSingleLineItem(bundleProduct, state.pack) ||
      pickVariantForPack(bundleProduct, state.pack);

    const variantCount = (bundleProduct?.variants && Array.isArray(bundleProduct.variants)) ? bundleProduct.variants.length : 0;
    if (!bundleVariant && variantCount === 1) {
      bundleVariant = pickFirstAvailableVariant(bundleProduct);
    }
    if (bundleVariant) {
      const qty = getSelectedPackQuantity();
      populateQtyOptions(bundleVariant);
      updateQtySelectDisplay();
      updateTopTotals(bundleVariant, qty);
      // Keep the theme price markup in sync (even if hidden) for consistency.
      updateThemePrice(bundleVariant, qty);
      if (addBtn) {
        addBtn.dataset.variantId = String(bundleVariant.id);
        addBtn.disabled = !bundleVariant.available;
        setAddButtonText(bundleVariant.available ? 'Add to Cart' : 'Sold Out');
      }
      if (hint) hint.textContent = '';
      return;
    }

    if (addBtn) {
      addBtn.dataset.variantId = '';
      addBtn.disabled = true;
      setAddButtonText('Unavailable');
    }
    if (hint) {
      if (!Array.isArray(relatedBundles) || relatedBundles.length === 0) {
        hint.textContent =
          'No related bundle products found. Add the virtual bundle product(s) to “PDP Related Bundles” and ensure they’re published.';
      } else if (bundleProduct && (!bundleProduct.variants || !Array.isArray(bundleProduct.variants) || bundleProduct.variants.length === 0)) {
        hint.textContent =
          'Related bundle product found, but it has no variants available. Ensure it’s published and has variants.';
      } else {
        hint.textContent =
          'Unable to match a valid bundle variant. Ensure the related bundle products are published and include the expected pack variant.';
      }
    }
  }

  function updateQtySelectDisplay() {
    if (!qtyInput) return;

    // We hide the native selected text in CSS and render our own overlay label.
    if (qtyInput.tagName === 'SELECT') {
      const selectedOption = qtyInput.options[qtyInput.selectedIndex];
      const displayText = selectedOption?.getAttribute('data-abbr') || selectedOption?.textContent || '1 Pack';

      qtyInput.setAttribute('title', selectedOption?.textContent || displayText);
      qtyInput.setAttribute('data-display-text', displayText);
      if (qtyDisplay) qtyDisplay.textContent = displayText;
      return;
    }

    const raw = qtyInput.value;
    const qty = Math.max(1, Number.parseInt(raw || '1', 10) || 1);
    const displayText = `${qty} Pack${qty !== 1 ? 's' : ''}`;
    if (qtyDisplay) qtyDisplay.textContent = displayText;
  }

  async function addBundleVariantToCart() {
    if (!addBtn) return;
    if (addBtn.classList.contains('loading')) return;
    const variantId = addBtn.dataset.variantId;

    if (!variantId) return;
    setLoadingState(true);

    const qtyRaw = qtyInput?.value;
    const qty = Math.max(1, Number.parseInt(qtyRaw || '1', 10) || 1);

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', String(qty));

    // Include sections for cart drawer refresh (Dawn pattern)
    if (cart && cart.getSectionsToRender) {
      formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
    }

    const config = (typeof fetchConfig === 'function') ? fetchConfig('javascript') : { method: 'POST', headers: {} };
    config.headers = config.headers || {};
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    let res;
    try {
      res = await fetch(`${routes.cart_add_url}`, config);
    } catch (e) {
      if (hint) hint.textContent = 'Unable to add to cart. Please try again.';
      setLoadingState(false);
      return;
    }
    let json;
    try {
      json = await res.json();
    } catch (e) {
      if (hint) hint.textContent = 'Unable to add to cart (unexpected response from Shopify).';
      setLoadingState(false);
      return;
    }
    if (json.status) {
      if (hint) {
        hint.textContent = json.description || json.message || 'Unable to add to cart.';
      }
      setLoadingState(false);
      return;
    }

    if (cart && cart.renderContents) {
      cart.renderContents(json);
      if (cart.classList && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
    }

    setLoadingState(false);
    updateUI();
    window.EGAtcFeedback?.success(addBtn);
  }

  // Wire up events
  sizeInputs.forEach(i => i.addEventListener('change', updateUI));
  if (qtyInput && qtyInput.tagName === 'SELECT') {
    // Make the native select behave like the tray pack dropdowns (scrollable list).
    qtyInput.addEventListener('focus', function() {
      this.setAttribute('size', '6');
    });

    qtyInput.addEventListener('blur', function() {
      this.removeAttribute('size');
    });

    qtyInput.addEventListener('change', function() {
      this.blur();
      updateQtySelectDisplay();
      updateUI();
    });
  } else if (qtyInput) {
    qtyInput.addEventListener('input', () => {
      updateQtySelectDisplay();
      updateUI();
    });
  }

  if (addBtn) addBtn.addEventListener('click', (e) => {
    e.preventDefault();
    addBundleVariantToCart();
  });

  updateUI();
  updateQtySelectDisplay();
})();
